import { cn } from '../../lib/utils'

interface PageHeaderProps {
  title: string
  subtitle?: string
  badge?: string
  action?: React.ReactNode
  className?: string
}

export function PageHeader({ title, subtitle, badge, action, className }: PageHeaderProps) {
  return (
    <div className={cn('flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between', className)}>
      <div>
        {badge ? (
          <span className='inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-semibold tracking-wide text-primary-700'>
            {badge}
          </span>
        ) : null}
        <h1
          className={cn(
            'text-2xl font-semibold text-neutral-900',
            badge ? 'mt-3' : undefined
          )}
        >
          {title}
        </h1>
        {subtitle ? <p className='text-sm text-neutral-600 mt-1'>{subtitle}</p> : null}
      </div>
      {action ? <div className='flex-shrink-0'>{action}</div> : null}
    </div>
  )
}
